import { RequirementDefinitionTemplateForm } from "../../types";
import {
  CreateRequirementDefinitionSharedFileMimeType,
  CreateRequirementDefinitionSharedFilePartialForm
} from "../../../../../Requirements/modules/SharedFile/types";
import { CreateSharedFilePartialForm } from "../../../../modules/SharedFile/createRequirementDefinition/CreateSharedFilePartialForm";
import { WSPanel } from "@wingspanhq/fe-component-library";
import * as Yup from "yup";
import { MIME_TYPES_VALUES } from "../../../../modules/SharedFile/createRequirementDefinition/utils";

type StandardSharedFileValues = {
  instructions?: string;
  mimeTypes: Partial<
    Record<CreateRequirementDefinitionSharedFileMimeType, boolean>
  >;
};

export const STANDARD_SHARED_FILE_FORM: RequirementDefinitionTemplateForm<
  StandardSharedFileValues,
  CreateRequirementDefinitionSharedFilePartialForm
> = {
  getDefaultValues: template => ({
    instructions: "",
    mimeTypes: {}
  }),
  mapFormData(values) {
    const data = {
      ...values
    };

    return data;
  },
  partialForm: (
    <WSPanel>
      <CreateSharedFilePartialForm />
    </WSPanel>
  ),
  validationSchema: Yup.object().shape({
    mimeTypes: Yup.object()
      .test("isNotEmpty", "At least one MIME type is required", value => {
        return (
          value &&
          Object.keys(value).length > 0 &&
          Object.keys(value).every(
            key => MIME_TYPES_VALUES[key as keyof typeof MIME_TYPES_VALUES]
          ) &&
          Object.values(value).some(Boolean)
        );
      })
      .required("Required") as Yup.AnyObjectSchema,
    instructions: Yup.string()
  })
};
